var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C10.5021 0 10.9091 0.407014 10.9091 0.909091V4.54545C10.9091 5.04753 10.5021 5.45455 10 5.45455C9.49792 5.45455 9.09091 5.04753 9.09091 4.54545V0.909091C9.09091 0.407014 9.49792 0 10 0Z",
    fill: "#5046E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.5455C10.5021 14.5455 10.9091 14.9525 10.9091 15.4545V19.0909C10.9091 19.593 10.5021 20 10 20C9.49792 20 9.09091 19.593 9.09091 19.0909V15.4545C9.09091 14.9525 9.49792 14.5455 10 14.5455Z",
    fill: "#5046E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9299 2.9299C3.28492 2.57488 3.86053 2.57488 4.21555 2.9299L6.78828 5.50263C7.1433 5.85765 7.1433 6.43326 6.78828 6.78828C6.43326 7.1433 5.85765 7.1433 5.50263 6.78828L2.9299 4.21555C2.57488 3.86053 2.57488 3.28492 2.9299 2.9299Z",
    fill: "#5046E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2117 13.2117C13.5667 12.8567 14.1423 12.8567 14.4974 13.2117L17.0701 15.7844C17.4251 16.1395 17.4251 16.7151 17.0701 17.0701C16.7151 17.4251 16.1395 17.4251 15.7844 17.0701L13.2117 14.4974C12.8567 14.1423 12.8567 13.5667 13.2117 13.2117Z",
    fill: "#5046E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 9.49792 0.407014 9.09091 0.909091 9.09091H4.54545C5.04753 9.09091 5.45455 9.49792 5.45455 10C5.45455 10.5021 5.04753 10.9091 4.54545 10.9091H0.909091C0.407014 10.9091 0 10.5021 0 10Z",
    fill: "#5046E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5455 10C14.5455 9.49792 14.9525 9.09091 15.4545 9.09091H19.0909C19.593 9.09091 20 9.49792 20 10C20 10.5021 19.593 10.9091 19.0909 10.9091H15.4545C14.9525 10.9091 14.5455 10.5021 14.5455 10Z",
    fill: "#5046E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78828 13.2117C7.1433 13.5667 7.1433 14.1423 6.78828 14.4974L4.21555 17.0701C3.86053 17.4251 3.28492 17.4251 2.9299 17.0701C2.57488 16.7151 2.57488 16.1395 2.9299 15.7844L5.50263 13.2117C5.85765 12.8567 6.43326 12.8567 6.78828 13.2117Z",
    fill: "#5046E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0701 2.9299C17.4251 3.28492 17.4251 3.86053 17.0701 4.21555L14.4974 6.78828C14.1423 7.1433 13.5667 7.1433 13.2117 6.78828C12.8567 6.43326 12.8567 5.85765 13.2117 5.50263L15.7844 2.9299C16.1395 2.57488 16.7151 2.57488 17.0701 2.9299Z",
    fill: "#5046E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b97617526f2d57da3d2d4e282b721798.svg";
export { ForwardRef as ReactComponent };